// @ts-nocheck
import React from 'react';
import Tooltip from '../../ui/Tooltip';

interface IntFieldConfig {
  min?: number;
  max?: number;
  placeholder?: string;
}

interface DynamicIntFieldProps {
  fieldId: string;
  label: string;
  description?: string;
  tooltip?: string;
  value: number;
  onChange: (value: number) => void;
  config: IntFieldConfig;
  isRequired?: boolean;
  error?: string;
}

export default function DynamicIntField({
  fieldId,
  label,
  description,
  tooltip,
  value,
  onChange,
  config,
  isRequired,
  error
}: DynamicIntFieldProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label htmlFor={fieldId} className="text-xs font-medium text-gray-300">
          {label}
          {isRequired && <span className="text-red-400 ml-1">*</span>}
        </label>
        {tooltip && (
          <Tooltip content={tooltip}>
            <div className="w-4 h-4 bg-gray-700/50 border border-gray-600 rounded-full flex items-center justify-center cursor-help hover:bg-gray-600/50 transition-colors duration-200">
              <span className="text-xs text-gray-300 font-medium">?</span>
            </div>
          </Tooltip>
        )}
      </div>
      
      {description && (
        <p className="text-xs text-gray-400">{description}</p>
      )}
      
      <input
        type="number"
        id={fieldId}
        value={value || ''}
        onChange={handleChange}
        min={config.min}
        max={config.max}
        placeholder={config.placeholder || 'Enter a number...'}
        className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-purple-500 focus:ring-1 focus:ring-purple-500/20"
      />
      
      {(config.min !== undefined || config.max !== undefined) && (
        <p className="text-xs text-gray-500">
          {config.min !== undefined && config.max !== undefined
            ? `Range: ${config.min} - ${config.max}`
            : config.min !== undefined
            ? `Min: ${config.min}`
            : `Max: ${config.max}`}
        </p>
      )}
      
      {error && (
        <p className="text-xs text-red-400">{error}</p>
      )}
    </div>
  );
}